module.exports = __webpack_public_path__ + "img/03.e2d16a1b.png";